import { z } from "zod";
import {
  PHONE_1,
  PHONE_2,
  ACCOUNT_NUMBER,
  BANK_NAME,
  CURRENCY,
  LEASE_DUE_DATE,
  MONTHLY_DUE_DATE,
  ROUTING_NUMBER,
  YEARLY_DUE_DATE,
} from "./consts";

export const financeSchema = z.object({
  [YEARLY_DUE_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
  [MONTHLY_DUE_DATE]: z.string().optional(),
  [LEASE_DUE_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
  [CURRENCY]: z.string().optional(),
  [BANK_NAME]: z.string().optional(),
  [ROUTING_NUMBER]: z.string().optional(),
  [ACCOUNT_NUMBER]: z.string().optional(),
  [PHONE_1]: z.string().optional(),
  [PHONE_2]: z.string().optional(),
});

export type financeFormValues = z.infer<typeof financeSchema>;